<template>
	<div class="right_body action_body">
		<span class="btn right_sub_btn save_btn" @click="submitData">提交数据</span>
		<el-tabs v-model="activeName">
			<el-tab-pane label="库位数据" name="base"></el-tab-pane>
		</el-tabs>

		<table class="add_tab">
			<tr>
				<th width="160">工厂编码</th>
				<td>
					<el-autocomplete
					  v-model="fromData.factoryCode"
					  :fetch-suggestions="querySearchAsync"
					  placeholder="请输入工厂编码"
					  :trigger-on-focus="false"
					  @select="handleSelect"
					  @keyup.enter.native="enterHandleSelect"
            @blur="enterHandleSelect"
					  ref="factoryAuto"
					></el-autocomplete>
				</td>
			</tr>
			<tr>
				<th>工厂描述</th>
				<td>
					<el-input :disabled="true" v-model="fromData.factoryDesc" autocomplete="off" placeholder="请输入"></el-input>
				</td>
			</tr>
			<tr>
				<th>库存地点编码</th>
				<td><el-input v-model="fromData.inventoryCode" :disabled="fromData.inventoryId ? true : false" autocomplete="off" placeholder="请输入"></el-input></td>
			</tr>
			<tr>
				<th>库存地点描述</th>
				<td><el-input v-model="fromData.inventoryDesc" autocomplete="off" placeholder="请输入"></el-input>	</td>
			</tr>
			<tr>
				<th height="40">默认库存地</th>
				<td>
					<el-radio v-model="fromData.isDefault" label="1">是</el-radio>
					 <el-radio v-model="fromData.isDefault" label="2">不是</el-radio>
				</td>
			</tr>
			<tr>
				<th height="40">是否允许MRP</th>
				<td>
					<el-radio v-model="fromData.isMrp" label="1">是</el-radio>
					<el-radio v-model="fromData.isMrp" label="2">不是</el-radio>
				</td>
			</tr>
			<tr>
				<th height="40">是否允许负库存</th>
				<td>
					<el-radio v-model="fromData.isNegativeInventory" label="1">是</el-radio>
					<el-radio v-model="fromData.isNegativeInventory" label="2">不是</el-radio>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import {fstockApi,factoryApi} from 'api/base.js';
export default {
	components:{

	},
    data() {
      return {
        activeName: 'base',
        id:'',
        listArr:[],
        listArrRes: [],
        isEdit:false,
        fromData:{
        }
      };
    },
    created(){
      this.id = this.$route.params.id;
      this.getInit();
    },
    mounted() {
      //this.restaurants = this.listArr;
    },
    //监测变化
    watch:{

    },
    methods: {
      handleClick(tab, event) {

      },
      changeDefault(val){
        console.log(val);
      },
      //初始数据
      async getInit(){
        //获取工厂
        let factoryList = await this.$post(factoryApi.list,this.$store.state.getAllPage);
        if(!factoryList.status) return false;
        this.listArr = factoryList.data.list;
        this.listArr.forEach((item,index)=>{
          item.value = item.factoryCode + ' ' +item.factoryDesc;
        });
        //获取详细信息
        if(this.id){
          let info = await this.$get(fstockApi.find,{'inventoryId':this.id});
          if(!info.status) return false;
          this.fromData = info.data;
          this.isEdit = true;
        }
      },
      querySearchAsync(queryString, cb) {
        var restaurants = this.listArr;
        var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
        this.listArrRes = results;
        cb(results);
      },
      createStateFilter(queryString) {
        return (state) => {
          if(state.value){
            return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          }
        };
      },
      //输入工厂加车事件
      enterHandleSelect(){
        if(!this.fromData.factoryCode) return;
        if(this.listArrRes.length){
          let item = this.listArrRes[0];
          this.handleSelect(item);
        }else{
          this.$alert('没有此工厂', '提示', {
            confirmButtonText: '知道了'
          });
          this.handleSelect({});
        }
        this.$refs.factoryAuto.close();
        this.$refs.factoryAuto.$children[0].blur();
      },
      //选择后
      handleSelect(item) {
        this.$set(this.fromData,'factoryCode',item.factoryCode);
        this.$set(this.fromData,'factoryDesc',item.factoryDesc);
        this.$set(this.fromData,'factoryId',item.factoryId);
      },
      //提交数据
      async submitData(){
        let id = this.$route.params.id;
        var postUrl = fstockApi.add;
        if(id)	postUrl = fstockApi.edit;
        if(!this.fromData.factoryId){
          this.$message.error('请选择工厂');
          return false;
        }
        if(!this.fromData.factoryId){
          this.$message.error('请选择工厂');
          return false;
        }
        if(!this.fromData.inventoryCode){
          this.$message.error('请输入库位编码');
          return false;
        }
        let res = await this.$post(postUrl,this.fromData);
        if(res.status){
          if(!this.isEdit) this.fromData = {};
          this.$alert(res.msg, '操作提示', {
            confirmButtonText: '知道了'
          })
        }else{
          this.$message.error(res.errorMsg);
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>

</style>
